module.exports = __webpack_public_path__ + "img/46.7688413b.png";